import { expand } from 'uri-template-lite';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { PageRequestParams } from '../../common/queryClient';
import { apiClient } from '../../common/ApiClient';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';
import { DashboardType, ValidationDashboardListDto } from '../types';
import { ValidationDashboardListPageSchema } from '../schema/ValidationDashboardListSchema';

const getValidationDashboards = (
  params: {
    dataObjectDescriptionId: number;
    dashboardType: DashboardType;
    createdBy?: string;
  } & PageRequestParams,
) =>
  apiClient
    .get<
      ValidationDashboardListDto[]
    >(expand(ValidationDashboardUrl.SEARCH, params))
    .then((response) => ValidationDashboardListPageSchema.parse(response.data));

export const useValidationDashboardsQuery = createApiQueryHook(
  ['validationDashboards'],
  getValidationDashboards,
);
